import { defineStore } from 'pinia';

export const useRoomsStore = defineStore('roomsStore', {
  state: () => ({
    standardRoomCode: 'STDRM',
    rooms: [
      {
        destinationName: '',
        hotelName: '',
        room: 'STDRM',
        roomDescription: 'Standard Room'
      }
    ]
  }),
  getters: {
    selectRooms: (state) => state.rooms
  }
});
